module.exports = __webpack_public_path__ + "img/picto-user.6ee054f3.png";